// TODO: apply it generally and not just to this component

import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const tabs = [
  { id: '#referents-tab', view: 'guest_referents', container: '#referents' },
  { id: '#relatives-tab', view: 'guest_relatives', container: '#relatives' },
];
const loadedComponents = {};

async function loadComponent(id, tabUrl, view, container) {
  try {
    const { data } = await apiConnector().get(`${tabUrl}?view=${view}`);
    document.querySelector(container).innerHTML = data;
  } catch (error) {
    console.error(error);
  } finally {
    loadedComponents[id] = true;
  }

  window.updateVueInstances();
}

function setupTabListeners() {
  tabs.forEach((tab) => {
    const tabElement = document.querySelector(tab.id);
    const dataset = tabElement.dataset;
    const tabUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}/guest_period_data_sets/${dataset['guestPeriodDataSetId']}/guests/${dataset['guestId']}/load_tab_resources`;

    if (tabElement) {
      tabElement.addEventListener('click', async () => {
        if (!loadedComponents[tab.id]) await loadComponent(tab.id, tabUrl, tab.view, tab.container);
      });
    } else {
      console.error(`Elemento ${tab.id} non trovato.`);
    }
  });
}

const init = () => {
  try {
    setupTabListeners();
  } catch (e) {
    errorManager(e);
  }
};

window.GuestTab = {
  init: init,
};
